import { useInfiniteQuery } from "@tanstack/react-query";
import collectionApiClient, { CollectionLabel } from "../../../api/collection";

const useCollectionLabelsQuery = (
  textSearch: string = "",
  limit: number = 20,
  sort?: Record<string, 1 | -1>,
) => {
  const fetchLabels = async (
    pageParam: {
      skip?: number;
      limit?: number;
    },
    query: string,
  ): Promise<CollectionLabel[]> => {
    const { skip = 0, limit: pageLimit = limit } = pageParam;

    const result = await collectionApiClient.getCollectionLabels({
      query,
      skip,
      limit: pageLimit,
      sort,
    });

    return result;
  };

  const query = useInfiniteQuery<CollectionLabel[], Error>({
    queryKey: ["collection-labels", textSearch, limit, sort],
    queryFn: ({ pageParam }) =>
      fetchLabels({ ...(pageParam ?? { skip: 0, limit }) }, textSearch),
    getNextPageParam: (lastPage, allPages) => {
      if (lastPage.length < limit) {
        return undefined;
      }
      const totalFetched = allPages.reduce((acc, page) => acc + page.length, 0);
      return { skip: totalFetched, limit };
    },
    initialPageParam: { skip: 0, limit },
  });

  return {
    ...query,
    data: query.data?.pages.flat() || [],
  };
};

export default useCollectionLabelsQuery;
